import LayoutActividad from "../../../components/LayoutActividad";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import Imagen2 from "../../../images/modulo12/inca.png";
import Imagen3 from "../../../images/modulo12/puna.png";
import GuiaDocente from "../../../components/GuiaDocente";

const Actividad4 = () => {
  const infoUnidad = modulo12.content[1];
  const infoAct = modulo12.content[1].activities[5];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo12.content[1].name}: ${modulo12.content[1].activities[6].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[1].path}/${modulo12.content[1].activities[6].path}`,
    titlePrev: `${modulo12.content[1].name}: ${modulo12.content[1].activities[4].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[1].path}/${modulo12.content[1].activities[4].path}`,
  };

  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>

      <div className="bg-light p-3 p-md-5 mt-4">
        <div className="row mt-3 align-items-center">
          <div className="col-md-8 col-12 p-3 p-md-3">
          <h2 className="mb-4">Una historia desigual</h2>

            <p>
              En nuestra historia han existido siempre diferentes grupos
              sociales.
            </p>
            <p>
              Durante el <strong>incanato</strong>, había gente con mucho poder,
              como los incas y los jefes o curacas de distintos lugares. Otros
              grupos con menos poder eran los artesanos y los agricultores.
            </p>
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen2} className="img-fluid" alt="Peruanos" />
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen3} className="img-fluid" alt="Peruanos" />
          </div>
          <div className="col-md-8 col-12 p-4 p-md-3">
            <p>
              Cuando se estableció el <strong>virreinato</strong>, se formaron
              otros grupos nuevos. En esa época era muy importante el origen de
              las personas, su ocupación y sus recursos.
            </p>
            <p>
              Luego de la <strong>independencia</strong> de los españoles,
              algunos se hicieron muy ricos y otros, como los indígenas,
              siguieron siendo muy pobres.
            </p>
          </div>
        </div>
      </div>
      <GuiaDocente>
        <ul>
          <li>Lea el texto Una historia desigual.</li>

          <li>
            Hay que resaltar que, a lo largo de la historia del país, siempre
            han existido grupos sociales distintos. Explique a niños y niñas que
            por grupo social se entiende un número de personas que comparten
            ciertas características –por ejemplo, una misma actividad o las
            mismas ideas políticas– y mantienen una interacción constante. Estos
            grupos sociales pueden estar vinculados de distintas maneras y se
            relacionan con el poder también de manera distintas. Por ejemplo, en
            el incanato, las personas vinculadas al inca por lazos de parentesco
            eran las más poderosas. Posteriormente, durante el virreinato, lo
            que más peso tenía era el origen de las personas. Poco a poco, el
            poder de las personas se fue relacionando más a sus recursos, así se
            fueron consolidando grupos sociales con más dinero y otros con menos
            dinero. Esto ha llevado a que el Perú sea un país con desigualdades
            entre su población.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad4;
